import {
  Component,
  Injector,
  OnInit,
  ElementRef,
  ViewChild,
  Renderer2,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from '@app/@core/entities/app-constants';
import { SocketAdapterService } from '@app/@core/services/socket-adapter.server';
import { AuthState } from '@core/auth/auth.models';
import { selectAuth } from '@core/auth/auth.selectors';
import { AppState } from '@core/core.state';
import { AlertService } from '@core/services/alert.service';
import { AuthService } from '@core/services/auth.service';
import { LocalService } from '@core/services/local.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { environment } from '@env/environment';
import { TranslateHandlerService } from '@app/shared/modules/page-header/translate-handler.service';
import { OidcSecurityService, AuthOptions  } from 'angular-auth-oidc-client';
import { DatePipe } from '@angular/common';
interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class LoginComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('showhideinput') input;
  @ViewChild('ngOtpInput') ngOtpInputRef;
  @ViewChild('proceedButton') proceedButton: ElementRef;
  value3!: string;
  cities: City[] = [];
  selectedCity1!: City;
  loginForm!: FormGroup;
  passwordForm!: FormGroup;
  validateForm : FormGroup;
  datePipe: DatePipe = new DatePipe('en-US');
  isTokenExpired:boolean = false;
  otpForm!: FormGroup;
  show!: boolean;
  disabledLoginPage!: boolean;
  submitStatus!: string;
  submitSecretStatus!: string;
  errorStatus?: string;
  closeResult = '';
  isAuthenticated$!: Observable<AuthState>;
  localstorage: LocalService;
  // primengConfig: PrimeNGConfig;
  isOtpSent: boolean;
  socketAdapter: SocketAdapterService;
  sessionKey!: string;
  recaptchaSiteKey: string;
  recaptchaToken: string;
  isTimerDone: boolean = false;
  time: string;
  count: any;
  visible: boolean = false;
  userId: string;
  showPasswordExpiryModal: boolean = false;
  showLanguage: boolean = false;
  isMailOtp: boolean = false;
  loginPass: boolean = false;
  showAdditionalFields: boolean = false;
  showPersonIdPage = false;
  personIdRoles = new Set(['cpastaff','casa', 'courtsupport', 'mcostaff']);
  dobRoles = new Set(['dfcsfosterparent', 'parent']);
  currentDate = new Date();
  isVerifyUser : any = 'Verify';
  isUserInfo : any;
  identityVerified = false;
  /* Google re-captcha onfiguration section  Starts */
  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;
  @ViewChild('langInput') langInput: ElementRef;
  @ViewChild('accept') accept: ElementRef;
  @ViewChild('langselect') langselect: ElementRef;
  @ViewChild('emailAddress') emailAddress: ElementRef;

  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  setFocus1: boolean;
  setFocus2: boolean;
  setFocus3: boolean;
  setfocuspass: boolean;
  setfocusemail: boolean;
  /* Google re-captcha onfiguration section  - Ends */
  showRoleSelection = false;
  rolesOptions: any[] = [];
  selectedRole: any;
  isDefaultRole: boolean = false; 
  loginStatus:string=''
  selectedRoleObj:any;
  userDetails:any;
  showDobPage: boolean;
  constructor(
    injector: Injector,
    private store$: Store<AppState>,
    private _router: Router,
    private activateRoute : ActivatedRoute,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService,
    private authService: AuthService,
    private renderer: Renderer2,
    private transalteHandler: TranslateHandlerService,
    private oidcService: OidcSecurityService,
    private cdr: ChangeDetectorRef

  ) {
    this.localstorage = injector.get<LocalService>(LocalService);
    this.socketAdapter = injector.get<SocketAdapterService>(SocketAdapterService);
    this.submitStatus = 'Submit';
    this.disabledLoginPage = false;
    this.recaptchaSiteKey = environment.recaptchaSiteKeyV3;
    this.renderer.addClass(document.body, 'clsRemoveTranslate');
  }
  ngAfterViewChecked(): void {
    if (this.accept && this.setFocus1) {
      setTimeout(() => {
        this.accept.nativeElement.focus();
      }, 200);
      this.setFocus1 = false;
    }
    if (this.input && this.setfocuspass) {
      setTimeout(() => {
        this.input.nativeElement.focus();
      }, 200);
      this.setfocuspass = false;
    }
    if (this.emailAddress && this.setfocusemail) {
      setTimeout(() => {
        this.emailAddress.nativeElement.focus();
      }, 200);
      this.setfocusemail = false;
    }
    if (this.langselect && this.setFocus2) {
      this.langselect.nativeElement.focus();
      this.setFocus2 = false;
    }
    if (this.setFocus3) {
      const googleTranElement = document.getElementById('google_translate_element');
      googleTranElement.getElementsByTagName('select')[0].focus();
      this.setFocus3 = false;
    }
    if (this.ngOtpInputRef) {
      const otp = Object.values(document.getElementsByClassName('otp-input'));
      otp.forEach((element: any, index) => {
        element.title = 'digit' + (index + 1);
        element.setAttribute('aria-label', 'digit' + (index + 1));
      });
    }
  }
  ngAfterViewInit(): void {
    const eles = document.getElementsByClassName('otp-input');
    for (let i = 0; i < eles.length; i++) {
      eles[i].setAttribute('aria-label', 'slide-dot');
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'clsRemoveTranslate');
  }

  ngOnInit(): void {
    this.transalteHandler.setTranslatedController();
    this.showLanguage = sessionStorage.getItem('showLanguage') == 'false' ? false : true;
    this.initializeForm();
    this.setfocusemail = true;
        history.pushState(null, '', location.href);
        this.localstorage.clear();
    const userToken = {
      token : this.activateRoute.snapshot.queryParamMap.get('token')
    }
    if(userToken?.token){
        this.verifyUserToken(userToken) 
    }     
    this.isAuthenticated$ = this.store$.pipe(select(selectAuth));
    this.isAuthenticated$.subscribe({
      next: (res) => {
        if (res.isAuthenticated) {
          const routeToAdmin = res.pages.some(a => a.name === 'Application Management');
          if (routeToAdmin) {
            this._router.navigate(['/pages/rbac']);
          } else {
            this._router.navigate(['/pages/page-design/list']);
          }
        }
      },
      error: (err) => {
        console.log(err);

        if (err.error) {
          if (err?.error?.errors?.code === 'NotAuthorizedException' || err?.error?.errors?.email === 'notFound') {
            this.alertService.error('Invalid Credentials.');
          } else this.alertService.error('System Error, Please try after sometime.');
        }
        this.submitStatus = 'Submit';
        this.submitSecretStatus = 'Submit';
      }
    });
  }

async decryptResponse(encryptedBase64: string): Promise<any> {
  const encryptionKey = environment.validateUrlSecretKey;
  const combined = Uint8Array.from(atob(encryptedBase64), c => c.charCodeAt(0));
  const iv = combined.slice(0, 16);
  const encryptedData = combined.slice(16);
  const keyBytes = Uint8Array.from(atob(encryptionKey), c => c.charCodeAt(0));
  const cryptoKey = await crypto.subtle.importKey(
    'raw', keyBytes, { name: 'AES-CBC' }, false, ['decrypt']
  );
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-CBC', iv }, cryptoKey, encryptedData
  );
  return JSON.parse(new TextDecoder().decode(decrypted));
}
  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 0;

    const prefix = minute < 10 ? '0' : '';

    this.count = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.time = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.isTimerDone = true;
        clearInterval(this.count);
        this.time = '';
      }
    }, 1000);
  }

  initializeForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(AppConstants.regexLoginEmail)]],
      recaptcha: ['']
    });
    this.passwordForm = this.fb.group({
      password: ['', Validators.required],
      conditions: [false, Validators.requiredTrue]
    });

    this.validateForm = this.fb.group({
      dob: [''],
      personId : ['']
    })
  }
  initializeOtpForm() {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.minLength(6), Validators.required]]
    });
  }
  open(content) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async handleSuccess(data) {
    console.log(data);
    this.recaptchaToken = data;
    const loginForm = this.loginForm.getRawValue();
    this.loginAPI(loginForm);
  }

  loginAPI(loginForm) {
    this.authService
      .validateMail({ email: loginForm.email.trim(), recaptchaToken: this.recaptchaToken, recaptchaVersion: '3', isWeb: true })
      .subscribe({
        next: (res: any) => {
          const user = res?.data;
          this.isUserInfo = res?.data;
          const userRole = user.rolecd;
          if (user?.isssoenabled) {
              if (user?.idpname && (user?.ssotype === 'ADFS'))
                this.loginWithFederated(user.idpname);
              else {
                this.alertService.error("You should not have an enough permission to login into COMET, Please contact Administrator.");
                this.submitStatus = 'Submit';
                this.submitSecretStatus = 'Submit';
              }
            } else {
          if (res?.data?.firstlogin?.length) {
              if (this.personIdRoles.has(userRole) || this.dobRoles.has(userRole)) {
             if (res.data.firstlogin[0]?.passwordExpired) {
                this.showPasswordExpiryModal = true;
                this.userId = res?.data?.id;
                return;
              }
               else{
                this.loginPass = false;
                this.showDobPage = this.dobRoles.has(userRole);
                this.showPersonIdPage = this.personIdRoles.has(userRole);
                this.cdr.detectChanges();
                return; 
               } 
              }           
            if (res.data.firstlogin[0]?.passwordExpired) {
              this.showPasswordExpiryModal = true;
              this.userId = res?.data?.id;
              this.proceedButton.nativeElement.focus();
            } else {
              this._router.navigate(['/auth/change-password'], {
                queryParams: { isTempPassword: 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() }
              });
            }
          }
           else {
            this.submitSecretStatus = 'Login';
            this.submitStatus = 'Login';
            this.loginPass = true;
            this.setfocuspass = true;
          }
        }
        },
        error: error => {
          if (error.error) {
            if (error?.error?.message) {
              this.alertService.error(error?.error?.message);
            } else if (error?.error?.errors) {
              this.alertService.error(error?.error?.errors);
            } else {
              this.alertService.error(AppConstants.errorMessage);
            }
            this.submitStatus = 'Submit';
            this.submitSecretStatus = 'Submit';
            if (this.captchaElem) this.captchaElem.resetCaptcha();
          }
        }
      });
  }

    isValidateUser() {
    const dob = this.validateForm.get('dob')?.getRawValue();
    const formattedDob = this.datePipe.transform(dob, 'yyyy/MM/d');
    const email = this.loginForm.get('email')?.getRawValue() || this.isUserInfo?.email;
    const getPersonId = this.validateForm.get('personId')?.getRawValue();
    let validate: any = {
      email: email,
      recaptchaVersion: '3',
      isWeb: true
    };
    if (this.showDobPage) {
      validate = { ...validate, dob: formattedDob };
    }
    if (this.showPersonIdPage) {
      validate = { ...validate, personid: getPersonId };
    }
    this.isValidateRoleToLogin(validate);
  }

  isValidateRoleToLogin(data:any){
    const loginForm = this.loginForm.getRawValue();
    this.isVerifyUser = 'Please wait ...'
    this.authService.validateRole(data).subscribe({
      next:(res:any)=>{
        if(res){
               if (res?.data?.firstlogin?.length){
                if (res.data.firstlogin[0]?.passwordExpired) {
                this.userId = res?.data?.id;
                this.identityVerified = true;   
                this.loginForm.get('email')?.setValue(data?.email);
                this.loginForm.get('recaptcha')?.setValue(data?.recaptchaVersion);
                this.navigateToResetPassword();
                return;
             }
             else {
               this.showDobPage = false;
               this.showPersonIdPage = false;
               this.loginPass = false;
               this._router.navigate(['/auth/change-password'], {
                queryParams: { isTempPassword: 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() }
              });
             }      
               }
               else{
                this.loginPass = true;
               }
            
        }
      },
      error:(err)=>{
        console.error(err.name);
        this.isVerifyUser = 'Verify';
        this.validateForm?.reset();
        this.alertService.error(err.error?.message);
      }
    })
  }
  login(action: string, otp?: string) {
    this.submitStatus = 'Please wait ...';
    this.submitSecretStatus = 'Please wait ...';
    this.errorStatus = '';
    const loginForm = this.loginForm.getRawValue();
    const passwordForm = this.passwordForm.getRawValue();
    let isInvalidOTP = false;
    if (action === 'login') {
      const loginform = this.loginForm.getRawValue();
      this.loginAPI(loginform);
      this.showAdditionalFields = true;
    

      // after captchaSuccess will got handleSuccess method
    } else if (this.isTimerDone && action !== 'resend') {
      this.alertService.error('OTP expired.');
      this.submitSecretStatus = 'Submit';
    } else {
      this.authService.login(loginForm.email.trim(), passwordForm.password.trim(), otp, this.sessionKey).subscribe({
        next: (res: any) => {
          if (res) {
            if (res.mfamode && res.mfamode == 'SMS') {
              this.isMailOtp = false;
            } else if (res.mfamode && res.mfamode == 'EMAIL') {
              this.isMailOtp = true;
            }
            if (res === 'MFA_CODE_SEND' || res?.challengeParameters?.OTP === 'Enter OTP sent to Email') {
              this.sessionKey = res.session;
              if (otp) {
                this.alertService.error(AppConstants.invalidOTP);
                this.setFocusOnOtp();
                isInvalidOTP = true;
                this.ngOtpInputRef.setValue(null);
              }
              if (action == 'otp' && isInvalidOTP) {
                this.isOtpSent = true;
                this.submitSecretStatus = 'Submit';
                return;
              } else if (action == 'resend') {
                clearInterval(this.count);
                this.time = null;
                this.isTimerDone = false;
                this.ngOtpInputRef.setValue(null);
                this.alertService.success(AppConstants.resendOTP);
                this.setFocusOnOtp();
              }
              this.isOtpSent = true;
              this.initializeOtpForm();
              this.submitSecretStatus = 'Submit';
              this.timer(AppConstants.TIMEOUT_DURATION_IN_MINUTES);
              this.alertService.success(AppConstants.resendOTP);
              return;
            }
            this.socketAdapter.connect();
            if (res?.action === 'TEMP_PASSWORD_RESET') {
              this._router.navigate(['/auth/change-password'], {
                queryParams: { isTempPassword: res?.action === 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() }
              });
            } else {
                this.authService.getLoggedInUserInfo();
            }
          }
        },
        error: error => {
          if (error.error) {
            if (error?.error?.message) {
              if (error?.error?.message === 'OTP retry attempt exceeded.') {
                this.onCancel();
                this.alertService.error('OTP retry attempt exceeded.');
              } else {
                this.alertService.error(error?.error?.message);
              }
            } else if (error?.error?.errors) {
              this.alertService.error(error?.error?.errors);
            } else {
              this.alertService.error(AppConstants.errorMessage);
            }
            this.submitStatus = 'Login';
            this.ngOtpInputRef?.setValue(null);
            this.submitSecretStatus = 'Submit';
          }
          if (error?.error?.message.toLowerCase() == 'otp retry attempt exceeded.') {
            this.submitSecretStatus = 'Submit';
            this.ngOtpInputRef.setValue(null);
          } else {
            this.submitStatus = 'Login';
          }
          this.captchaElem.resetCaptcha();
        }
      });
    }
  }

  sendOtp() {
    const otpFormDetails = this.otpForm.getRawValue();
    this.login('otp', otpFormDetails.otp);
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.input.nativeElement.type = 'text';
    } else {
      this.input.nativeElement.type = 'password';
    }
  }

  routeToChangePassword() {
    this._router.navigate(['/auth/forgot-password']);
  }

  // routeToDynamicPage(landingPage: any) {
  //   const orgid = sessionStorage.getItem('orgid');
  //   if (landingPage.route.includes('dynamic-search/search')) {
  //     const pageId = landingPage.route.split('/')[4];
  //     if (pageId) {
  //       this.authService.checkDynamicPagePermission(pageId);
  //     } else {
  //       this.authService.routeToDynamicPage(orgid).subscribe(res => {
  //         if (res && res.data.length) {
  //           const authorisedPages = res?.data?.filter(a => a?.activeVersion?.gridconfig);
  //           this.localstorage.setItem('selectedDynamicPage', authorisedPages[0]?.activeVersion?.id);
  //           if (authorisedPages && authorisedPages.length && authorisedPages[0]?.activeVersion?.gridconfig) {
  //             const gridPageRoute = `pages/dynamic-search/search/${authorisedPages[0]?.activeVersion?.id}`;
  //             this._router.navigate([gridPageRoute]);
  //             this.localstorage.setItem('dashboardRoute', gridPageRoute);
  //           }
  //         } else {
  //           this.alertService.error(
  //             'You don\'t have permissions to perform the following operations .Please Contact Administrator'
  //           );
  //         }
  //       });
  //     }
  //   } else {
  //     const landingPageRoute = `pages${landingPage?.route}`;
  //     this._router.navigate([landingPageRoute]);
  //     this.localstorage.setItem('dashboardRoute', landingPageRoute);
  //   }
  // }

  onCancel() {
    sessionStorage.clear();
    this.loginForm?.reset();
    this.otpForm?.reset();
    this.passwordForm?.reset();
    this.isOtpSent = false;
    this.submitStatus = 'Submit';
    this.submitSecretStatus = 'Submit';
    this.sessionKey = null;
    clearInterval(this.count);
    this.time = null;
    this.isTimerDone = false;
    this.loginPass = false;
    if (this.captchaElem) {
      this.captchaElem.resetCaptcha();
    }
    window.location.reload();
    this.initializeForm();
  }

  onResend() {
    this.login('resend');
  }

  patchOTP(value: string) {
    this.otpForm.patchValue({ otp: value });
  }

  showLanguageDialog() {
    this.visible = true;
    this.setFocus1 = true;
  }

  acceptLanguage() {
    this.visible = false;
    this.showLanguage = false;
    this.setFocus3 = true;
    sessionStorage.setItem('showLanguage', '');
    sessionStorage.setItem('showLanguagePage', 'false');
    const googleTranElement = document.getElementById('google_translate_element');
    googleTranElement.className = 'clsLangTrans';
  }
  navigateToResetPassword() {
    const loginForm = this.loginForm.getRawValue();
    const userRole = this.isUserInfo?.rolecd;
       if (!this.identityVerified && (this.personIdRoles.has(userRole) || this.dobRoles.has(userRole))) {
       this.loginPass = false;
       this.showDobPage = this.dobRoles.has(userRole);
       this.showPersonIdPage = this.personIdRoles.has(userRole);
       this.cdr.detectChanges();
       this.showPasswordExpiryModal = false;
       this.submitStatus = 'Submit';
      return;        
    }         
    this.authService.initialPasswordReset(this.userId).subscribe({
      next: (_res: any) => {
        this.identityVerified = false;
        this.closeShowExpiryModal();
        this._router.navigate(['/auth/change-password'], {
          queryParams: { isTempPassword: 'TEMP_PASSWORD_RESET', email: loginForm.email.trim() }
        });
      },
      error: (error) => {
        if (error.error) {
          if (error?.error?.message) {
            this.alertService.error(error?.error?.message);
          } else this.alertService.error(AppConstants.errorMessage);
        }
        this.submitStatus = 'Submit';
        this.submitSecretStatus = 'Submit';
        this.isVerifyUser = 'Verify';
      }
    });
  }
  close() {
    this.visible = false;
    this.setFocus2 = true;
  }
  closeShowExpiryModal() {
    this.showPasswordExpiryModal = false;
    this.setFocus1 = true;
    this.loginForm.reset();
    this.submitStatus = 'Submit';
  }
  setFocusOnOtp() {
    const otpFields = document.querySelectorAll('.otp-input'); // Adjust selector if needed
    if (otpFields.length > 0) {
      setTimeout(() => {
        (otpFields[0] as HTMLElement).focus();
      }, 200);
    }
  }
getMultiRoles() {
    this.authService.getMultiRole().subscribe({
      next: (roles: any) => {
        if (roles.length > 0) {
          this.showRoleSelection = true;
          this.loginPass = false;
          this.loginStatus = 'Login';
          this.rolesOptions = roles;
          this.userDetails = JSON.parse(
            this.localstorage?.getItem('userDetails') || '{}'
          );
          this.selectedRole = this.userDetails?.role || '';
          if (this.selectedRole) {
            this.selectedRoleObj = this.rolesOptions.find(
              r => r.roleCd === this.selectedRole
            );
            this.isDefaultRole = true;
          }
        } else {
          this.authService.getLoggedInUserInfo();
        }
      },
      error: err => {
        console.error(err.name);
      }
    });
  }

  onDropdownShow() {
    document.body.classList.add('p-dropdown-scroll-lock');
  }
  onRoleChange(role:any) {
    this.isDefaultRole=role==this.userDetails?.role?true:false;
    this.selectedRole=role;
    this.selectedRoleObj = this.rolesOptions.find(r => r.roleCd === role);

  }
  loginWithRole() {
    this.loginStatus = 'Please wait ...';
    if (!this.selectedRoleObj) {
      this.alertService.error(AppConstants.errorMessage);
      this.loginStatus = 'Login';
      return;
    }

    const info = {
      roleId: this.selectedRoleObj.roleId,
      is_default: this.isDefaultRole
    };

    this.authService.multiRolesChange(this.selectedRoleObj.roleId, info).subscribe({
      next: (res: any) => {
        if (res['data']) {
          this.localstorage.setItem('role_id', this.selectedRoleObj.roleId);
          this.localstorage.setItem('role_name', this.selectedRoleObj.roleName);
          this.authService.getLoggedInUserInfo();
        }
      },
      error: err => {
        console.log(err.name);
        this.alertService.error(AppConstants.errorMessage);
        this.loginStatus = 'Login';
      }
    });
  }
  loginWithFederated(idpname: string): void {
      const authOptions: AuthOptions = {
    customParams: {
      identity_provider: idpname
    }
  };

    this.oidcService.authorize(undefined, authOptions);
   }
verifyUserToken(userToken:any){
    if (userToken?.token) {
      this.authService.validateRoleToken(userToken).subscribe(
        {
        next: async (res: any) => {
          try {
            const getToken = res?.data?.token;
            const parsed = await this.decryptResponse(getToken);
            if (parsed.isValid && parsed.tokenStatus === 'ACTIVE' && !parsed?.isUserValidate) {
              if(this.personIdRoles.has(parsed?.roleCd) || this.dobRoles.has(parsed?.roleCd) ){
                this.loginForm.get('email')?.patchValue(parsed?.email);
                this.login('login'); 
                this.cdr.detectChanges();                
             }
              else{
              this.loginPass = false;
            }
            }
            else if(parsed.isUserValidate){
              this.loginPass = false;
            }
            else {
              this._router.navigate(['/verification-link-expired']);
            }
          } catch (e) {
            console.error('decrypt failed', e);
            this.loginForm.reset();
            this._router.navigate(['/verification-link-expired']);
          }
        },
        error: err => {
          this.loginForm.reset();
          this._router.navigate(['/verification-link-expired']);
          console.error(err, 'full error');
        }
      });
    }
}
}
